import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionImagemContainerService } from './section-imagem-container.service';
import { SectionImagemData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-section-imagem-container',
  template: `
    <fcp-section-imagem
      [sectionImagem]="data | async"
    ></fcp-section-imagem>
  `
})
export class SectionImagemContainerComponent implements OnInit {
  @Input() public id: string;
  public data: Observable<SectionImagemData>;
  constructor(private sectionImagemContainerService: SectionImagemContainerService) {}

  ngOnInit() {
    this.data = this.sectionImagemContainerService.getImagem(this.id);
  }
}
